import { NOT_INFORMED } from './status';

export { NOT_INFORMED };

export function displayText(value) {
  const text = String(value ?? '').trim();
  return text || NOT_INFORMED;
}

// SQL Server pode devolver bit como número ou string
export function formatBoolean(value, whenTrue, whenFalse) {
  if (value === true || value === 1 || value === '1' || value === 'true') return whenTrue;
  if (value === false || value === 0 || value === '0' || value === 'false') return whenFalse;
  return NOT_INFORMED;
}

export const formatSimplesNacional = (value) => formatBoolean(value, 'Sim', 'Não');

export function formatPhone(value) {
  const text = String(value ?? '').trim();
  if (!text) return NOT_INFORMED;

  const digits = text.replace(/\D/g, '');
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return text;
}
